module.exports = __webpack_public_path__ + "static/media/duabi-2.be706559.jpg";